import { provide, defineComponent, toRef } from 'vue-demi';
import { FormSymbol, FieldSymbol, SchemaMarkupSymbol, SchemaSymbol, SchemaExpressionScopeSymbol, SchemaOptionsSymbol, } from '../shared/context';
import { useAttach } from '../hooks/useAttach';
import { useInjectionCleaner } from '../hooks/useInjectionCleaner';
import h from '../shared/h';
import { Fragment } from '../shared/fragment';
export default defineComponent({
    name: 'FormProvider',
    inheritAttrs: false,
    props: ['form'],
    setup: function (props, _a) {
        var slots = _a.slots;
        var formRef = useAttach(toRef(props, 'form'));
        provide(FormSymbol, formRef);
        useInjectionCleaner([
            FieldSymbol,
            SchemaMarkupSymbol,
            SchemaSymbol,
            SchemaExpressionScopeSymbol,
            SchemaOptionsSymbol,
        ]);
        return function () { return h(Fragment, {}, slots); };
    },
});
//# sourceMappingURL=FormProvider.js.map